var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("防詐騙公告")]),_vm._v(" "),_vm._l((_vm.getfooter),function(item){return (item.name === '防诈骗公告')?_c('div',{staticClass:"instructions",attrs:{"id":item.name}},[_c('div',{staticClass:"instructionses",domProps:{"innerHTML":_vm._s(item.content)}})]):_vm._e()})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }